import { render, staticRenderFns } from "./adSense.vue?vue&type=template&id=60ec0b5e&scoped=true&"
import script from "./adSense.vue?vue&type=script&lang=js&"
export * from "./adSense.vue?vue&type=script&lang=js&"
import style0 from "./adSense.vue?vue&type=style&index=0&id=60ec0b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec0b5e",
  null
  
)

export default component.exports